// @ts-nocheck
import type { SerializerRegistry } from '@visualizer/types';

const version = 'v0_0_8';

const v0_0_8: SerializerRegistry = {
    version,
    binary: {},
};

export default v0_0_8;
